import { useEffect, useId, useRef, type ReactNode } from 'react'

export function NotePreviewOverlay({ children, onClose }: { children: ReactNode; onClose: () => void }) {
  const dialog = useRef<HTMLDialogElement>(null)
  const heading = useId()
  useEffect(() => {
    const element = dialog.current!
    const trigger = document.activeElement
    element.showModal()
    return () => {
      element.close()
      if (trigger instanceof HTMLElement && trigger.isConnected) trigger.focus({ preventScroll: true })
    }
  }, [])
  return <dialog ref={dialog} className="modal note-selection-dialog note-preview-dialog" aria-labelledby={heading}
    onCancel={event => { event.preventDefault(); onClose() }}>
    <div className="modal-box note-selection-dialog__panel">
      <h2 id={heading}>Note preview</h2>
      <div className="note-selection-dialog__scroll">{children}</div>
      <div className="modal-action"><button autoFocus type="button" className="btn btn-ghost" onClick={onClose}>Back to merging order</button></div>
    </div>
  </dialog>
}
